import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form/immutable';
import { push } from 'react-router-redux';

import {
  fetchTenantsRoutine,
  addTenantRoutine,
  upgradeTenantRoutine,
  getTaskCountRoutine,
  fetchInvoicesRoutine,
  getPaymentSourceRoutine,
  updatePaymentSourceRoutine,
  cancelAccountRoutine,
} from '../routines';
import {setMessage} from '../actions/messages';
import { post } from '../utils/rest';
import { showError, hideDialog } from '../actions/dialogs';
import { parseApiErrorCode } from '../utils/helper';
import { get } from '../utils/rest';
import { getTenantId, getIdToken } from '../utils/firebase';

import { FIREBASE_CONFIG } from '../config';

function fetchTenants() {
  // return getIdToken().then((idToken) => {
  //   return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/tenants`, {
  //     method: 'GET',
  //     headers: {
  //       Authorization: `Bearer ${idToken}`,
  //       Accept: 'application/json',
  //     },
  //   }).then((res) => {
  //     if (res.ok) {
  //       return res.json();
  //     }
  //
  //     return res.json().then((err) => {
  //       throw err;
  //     });
  //   });
  // });
  return get('/v1/tenants');
}

function* fetchTenantsSaga(action) {
  try {
    const resp = yield call(fetchTenants);
    yield put(fetchTenantsRoutine.success(resp));
  } catch (e) {
    console.error('Unable to fetch tenants', e);
    yield put(showError('Unable to fetch accounts', e.message || parseApiErrorCode(e.code)));
    yield put(fetchTenantsRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchFetchTenants() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(fetchTenantsRoutine.TRIGGER, fetchTenantsSaga);
}

function upgradeTenant({ tenantId, token, retentionPeriod }) {
  const payload = {
    tenantId,
    token,
    retentionPeriod,
  };

  return getIdToken().then((idToken) => {
    return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/tenants/${tenantId}/upgrade`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }

      return res.json().then((err) => {
        throw err;
      });
    });
  });
}

function* upgradeTenantSaga(action) {
  try {
    const resp = yield call(upgradeTenant, action.payload);
    yield put(upgradeTenantRoutine.success(resp));
    yield put(hideDialog('upgrade'));
  } catch (e) {
    console.error('Unable to update payment', e);
    yield put(showError('Unable to update payment', e.message || parseApiErrorCode(e.code)));
    yield put(upgradeTenantRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchUpgradeTenant() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(upgradeTenantRoutine.TRIGGER, upgradeTenantSaga);
}

function getTaskCount({ tenantId }) {
  return getIdToken().then((idToken) => {
    return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/tenants/${tenantId}/taskcount`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${idToken}`,
        Accept: 'application/json',
      },
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }

      return res.json().then((err) => {
        throw new Error(err);
      });
    }).then((resp) => {
      return resp.data;
    });
  });
}

function* getTaskCountSaga(action) {
  try {
    const resp = yield call(getTaskCount, action.payload);
    yield put(getTaskCountRoutine.success(resp));
  } catch (e) {
    console.error('Unable to retrieve task count', e);
    yield put(showError('Unable to retrieve task count', parseApiErrorCode(e.code)));
    yield put(getTaskCountRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchGetTaskCount() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(getTaskCountRoutine.TRIGGER, getTaskCountSaga);
}

function getPaymentSource({ tenantId }) {
  return getIdToken().then((idToken) => {
    return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/tenants/${tenantId}/paymentsource`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${idToken}`,
        Accept: 'application/json',
      },
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }

      return res.json().then((err) => {
        throw new Error(err);
      });
    }).then((resp) => {
      return resp.data;
    });
  });
}

function* getPaymentSourceSaga(action) {
  try {
    const resp = yield call(getPaymentSource, action.payload);
    yield put(getPaymentSourceRoutine.success(resp));
  } catch (e) {
    console.error('Unable to retrieve payment source', e);
    yield put(showError('Unable to retrieve payment source', parseApiErrorCode(e.code)));
    yield put(getPaymentSourceRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchGetPaymentSource() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(getPaymentSourceRoutine.TRIGGER, getPaymentSourceSaga);
}

function updatePaymentSource({ token }) {
  const payload = {
    token,
  };

  return getIdToken().then((idToken) => {
    return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/tenants/${getTenantId()}/paymentsource`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }

      return res.json().then((err) => {
        throw err;
      });
    });
  });
}

function* updatePaymentSourceSaga(action) {
  try {
    const resp = yield call(updatePaymentSource, action.payload);
    yield put(updatePaymentSourceRoutine.success(resp));
    yield put(hideDialog('creditcard'));
  } catch (e) {
    console.error('Unable to update payment source', e);
    yield put(showError('Unable to update payment source', e.message || parseApiErrorCode(e.code)));
    yield put(updatePaymentSourceRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchUpdatePaymentSource() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(updatePaymentSourceRoutine.TRIGGER, updatePaymentSourceSaga);
}

function getInvoices({ from, to } = {}) {
  return getIdToken().then((idToken) => {
    return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/tenants/${getTenantId()}/invoices`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${idToken}`,
        Accept: 'application/json',
      },
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }

      return res.json().then((err) => {
        throw new Error(err);
      });
    }).then((resp) => {
      return resp.data;
    });
  });
}

function* getInvoicesSaga(action) {
  try {
    const resp = yield call(getInvoices, action.payload);
    yield put(fetchInvoicesRoutine.success(resp));
  } catch (e) {
    console.error('Unable to retrieve invoices', e);
    yield put(showError('Unable to retrieve invoices', parseApiErrorCode(e.code)));
    yield put(fetchInvoicesRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchFetchInvoices() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(fetchInvoicesRoutine.TRIGGER, getInvoicesSaga);
}

function cancelAccount() {
  const tenantId = getTenantId();
  return getIdToken().then((idToken) => {
    return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/tenants/${tenantId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${idToken}`,
        Accept: 'application/json',
      },
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }

      return res.json().then((err) => {
        throw err;
      });
    });
  });
}

function* cancelAccountSaga(action) {
  try {
    const resp = yield call(cancelAccount, action.payload);
    yield put(cancelAccountRoutine.success(resp));
    yield put(setMessage('login', 'success', 'Your account has been deleted'));
    yield put(push('/logout'));
  } catch (e) {
    console.error('Unable to cancel account', e);
    yield put(showError('Unable to cancel account', e.message || parseApiErrorCode(e.code)));
    yield put(cancelAccountRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchCancelAccount() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(cancelAccountRoutine.TRIGGER, cancelAccountSaga);
}

function addTenant(request) {
  console.log('addTenant', request);

  // create employee
  const path = '/v1/tenants';
  return post(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(request),
  }, true).then((resp) => {
    return resp;
  });
}

function* addTenantSaga(action) {
  try {
    const { values } = action.payload;
    console.log('values', values.toJS());
    const tenant = yield call(addTenant, values.toJS());

    // const tenant = yield call(resp.json);
    console.log('tenant', tenant);

    yield put(addTenantRoutine.success(tenant));
  } catch (e) {
    console.error('Unable to register', e);
    yield put(addTenantRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchAddTenantSaga() {
  yield takeEvery(addTenantRoutine.TRIGGER, addTenantSaga);
}

export {
  watchFetchTenants,
  watchAddTenantSaga,
  watchUpgradeTenant,
  watchGetTaskCount,
  watchGetPaymentSource,
  watchUpdatePaymentSource,
  watchFetchInvoices,
  watchCancelAccount,
};



// WEBPACK FOOTER //
// ./src/sagas/tenants.js